module.exports = "/images/vendor/flag-icon-css/flags/4x3/ps.svg?42f2391e39ad07037687596ba3fbab75";